<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header px-0 mx-3">
              <div class="row g-3 align-items-center">
                <div class="col-md-6 col-sm-4">
                  <h4>Cronjob</h4>
                </div>
                <div class="col-md-6 col-sm-8">
                  <div
                    class="d-flex justify-content-sm-end align-items-center flex-wrap row-gap-2"
                  >
                    <router-link
                      to="/others-settings/cronjob-schedule"
                      class="btn btn-dark me-2"
                    >
                      <i class="ti ti-clock-hour-4 me-2"></i>Cron Schedule
                    </router-link>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#add_cronjob"
                      @click="openAddModal"
                    >
                      <i class="ti ti-circle-plus me-2"></i>Add Cronjob
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="card mb-3">
                <div
                  class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                >
                  <h5>Cronjob List</h5>
                  <div
                    class="d-flex align-items-center"
                    v-if="selectedIds.length"
                  >
                    <button
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      @click="handleBulkDelete"
                    >
                      <i class="ti ti-trash me-1"></i> Delete Selected
                    </button>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="custom-datatable-filter table-responsive">
                    <table class="table">
                      <thead class="thead-light">
                        <tr>
                          <th class="no-sort">
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="select-all"
                                :checked="isAllSelected"
                                @change="toggleSelectAll"
                              />
                            </div>
                          </th>
                          <th>Name</th>
                          <th>Schedule</th>
                          <th>Next Run</th>
                          <th>Last Run</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="loading">
                          <td colspan="7" class="text-center py-3">
                            Loading cron jobs...
                          </td>
                        </tr>
                        <tr v-if="!loading && !rows.length">
                          <td colspan="7" class="text-center py-3">
                            No cron jobs found.
                          </td>
                        </tr>
                        <tr v-for="job in rows" :key="job.id">
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="job.id"
                                v-model="selectedIds"
                              />
                            </div>
                          </td>
                          <td>
                            <h6 class="fw-medium">{{ job.name }}</h6>
                          </td>
                          <td>
                            {{ job.schedule_label || job.schedule || "-" }}
                          </td>
                          <td>
                            <div>
                              <p class="mb-0">
                                {{ formatDate(job.next_run_at) }}
                              </p>
                              <p class="mb-0">
                                {{ formatTime(job.next_run_at) }}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="mb-0">
                                {{ formatDate(job.last_run_at) }}
                              </p>
                              <p class="mb-0">
                                {{ formatTime(job.last_run_at) }}
                              </p>
                            </div>
                          </td>
                          <td>
                            <span
                              class="badge d-flex align-items-center badge-xs"
                              :class="
                                job.is_active
                                  ? 'badge-success'
                                  : 'badge-outline-secondary'
                              "
                            >
                              <i class="ti ti-point-filled me-1"></i>
                              {{ job.is_active ? "Running" : "Paused" }}
                            </span>
                          </td>
                          <td>
                            <div class="action-icon d-inline-flex">
                              <a
                                href="javascript:void(0);"
                                class="me-2"
                                @click="toggleJob(job)"
                              >
                                <i
                                  :class="
                                    job.is_active
                                      ? 'ti ti-player-pause'
                                      : 'ti ti-player-play'
                                  "
                                ></i>
                              </a>
                              <a
                                href="javascript:void(0);"
                                class="me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_cronjob"
                                @click="openEditModal(job)"
                              >
                                <i class="ti ti-edit"></i>
                              </a>
                              <a
                                href="javascript:void(0);"
                                class=""
                                @click="runJobNow(job)"
                              >
                                <i class="ti ti-clock-bolt"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!--Add Cronjob -->
  <div class="modal fade" id="add_cronjob">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add Cronjob</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleCreate">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.name"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Schedule</label>
                  <!-- using names from cron schedule store for now -->
                  <vue-select
                    :options="scheduleOptions"
                    placeholder="Select"
                    label="name"
                    v-model="createForm.schedule"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-2 d-flex align-items-center">
                    <div class="mb-3">
                      <label class="form-label">Next Run</label>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="createForm.nextDate"
                          class="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon">
                          <i class="ti ti-calendar text-gray-7"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <div class="input-icon w-100">
                        <a-time-picker
                          v-model:value="createForm.nextTime"
                          class="form-control timepicker"
                          placeholder="Choose"
                          use12-hours
                          format="h:mm a"
                          type="text"
                          :get-popup-container="getTimePopupContainer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.url"
                    placeholder="https://example.com/cron/report"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-1"
              />
              Add Cronjob
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Cronjob -->

  <!-- Edit Cronjob -->
  <div class="modal fade" id="edit_cronjob">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Edit Cronjob</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleUpdate">
          <div class="modal-body pb-0" v-if="editForm.id">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.name"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Schedule</label>
                  <vue-select
                    :options="scheduleOptions"
                    placeholder="Select"
                    label="name"
                    v-model="editForm.schedule"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-2 d-flex align-items-center">
                    <div class="mb-3">
                      <label class="form-label">Next Run</label>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="editForm.nextDate"
                          class="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon">
                          <i class="ti ti-calendar text-gray-7"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <div class="input-icon position-relative w-100">
                        <a-time-picker
                          v-model:value="editForm.nextTime"
                          class="form-control timepicker"
                          placeholder="Choose"
                          use12-hours
                          format="h:mm a"
                          type="text"
                          :get-popup-container="getTimePopupContainer"
                        />

                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.url"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body pb-0" v-else>
            <p class="mb-0">Select a cron job to edit.</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-1"
              />
              Save Cronjob
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Edit Cronjob -->
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import dayjs from "dayjs";
import { useCronJobStore } from "@/stores/settings/cronjob.store";
import { useCronScheduleStore } from "@/stores/settings/cron-schedule.store";
import { toast } from "@/utils/toast";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const dateFormat = "dd-MM-yyyy";

const cronJobStore = useCronJobStore();
const cronScheduleStore = useCronScheduleStore();

const rows = computed(() => cronJobStore.rows);
const loading = computed(() => cronJobStore.loading);
const saving = ref(false);

const getTimePopupContainer = (triggerNode) => triggerNode.parentNode;

const selectedIds = ref([]);

const createForm = reactive({
  name: "",
  schedule: "",
  nextDate: null,
  nextTime: null,
  url: "",
});

const editForm = reactive({
  id: null,
  name: "",
  schedule: "",
  nextDate: null,
  nextTime: null,
  url: "",
});

const scheduleOptions = computed(() =>
  cronScheduleStore.rows.map((r) => ({
    id: r.id,
    text: r.name,
  }))
);

//const scheduleOptions = computed(() => cronScheduleStore.rows);

const isAllSelected = computed(() => {
  return (
    rows.value.length > 0 && selectedIds.value.length === rows.value.length
  );
});

function toggleSelectAll(e) {
  if (e.target.checked) {
    selectedIds.value = rows.value.map((r) => r.id);
  } else {
    selectedIds.value = [];
  }
}

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function resetCreateForm() {
  createForm.name = "";
  createForm.schedule = "";
  createForm.nextDate = null;
  createForm.nextTime = null;
  createForm.url = "";
}

function openAddModal() {
  resetCreateForm();
}

function openEditModal(job) {
  editForm.id = job.id;
  editForm.name = job.name || "";

  // bind by ID, not label
  editForm.schedule = job.cron_schedule_id || null;

  editForm.url = job.url || "";

  if (job.next_run_at) {
    const d = dayjs(job.next_run_at); // ✅ dayjs instance

    // date-picker likely expects native Date → use toDate()
    editForm.nextDate = d.toDate();

    // a-time-picker expects dayjs → pass dayjs
    editForm.nextTime = d;
  } else {
    editForm.nextDate = null;
    editForm.nextTime = null;
  }
}

function buildDateTime(dateVal, timeVal) {
  if (!dateVal && !timeVal) return null;

  try {
    // Normalize base date
    let base;

    if (dateVal) {
      if (dateVal instanceof Date) {
        base = new Date(dateVal);
      } else if (
        dateVal &&
        typeof dateVal === "object" &&
        typeof dateVal.toDate === "function"
      ) {
        // dayjs or similar
        base = new Date(dateVal.toDate());
      } else {
        base = new Date(dateVal);
      }
    } else {
      base = new Date();
    }

    // Normalize time
    if (timeVal) {
      let timeDate;

      if (timeVal instanceof Date) {
        timeDate = timeVal;
      } else if (
        timeVal &&
        typeof timeVal === "object" &&
        typeof timeVal.toDate === "function"
      ) {
        // dayjs
        timeDate = timeVal.toDate();
      } else {
        timeDate = new Date(timeVal);
      }

      base.setHours(timeDate.getHours(), timeDate.getMinutes(), 0, 0);
    }

    return base.toISOString();
  } catch {
    return null;
  }
}

async function handleCreate() {
  saving.value = true;
  try {
    const payload = {
      name: createForm.name,
      schedule_id: createForm.schedule || null,
      next_run_at: buildDateTime(createForm.nextDate, createForm.nextTime),
      url: createForm.url,
    };
    await cronJobStore.create(payload);
    resetCreateForm();
  } catch (e) {
    // error already toasted in store
  } finally {
    saving.value = false;
  }
}

async function handleUpdate() {
  if (!editForm.id) {
    toast("No cron job selected", "error");
    return;
  }
  saving.value = true;
  try {
    const payload = {
      name: editForm.name,
      schedule_id: editForm.schedule || null,
      next_run_at: buildDateTime(editForm.nextDate, editForm.nextTime),
      url: editForm.url,
    };
    await cronJobStore.update(editForm.id, payload);
  } catch (e) {
    // already toasted
  } finally {
    saving.value = false;
  }
}

async function handleBulkDelete() {
  if (!selectedIds.value.length) return;
  try {
    await cronJobStore.bulkDelete(selectedIds.value);
    selectedIds.value = [];
  } catch {
    // toast inside store
  }
}

async function toggleJob(job) {
  if (!job?.id) return;
  await cronJobStore.toggle(job.id);
}

async function runJobNow(job) {
  if (!job?.id) return;
  await cronJobStore.runNow(job.id);
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString();
}

function formatTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

onMounted(async () => {
  await Promise.all([
    cronJobStore.fetchList(),
    cronScheduleStore.fetchList?.(),
  ]);
});
</script>


